"use strict";

define('evisions/uuid',[], function () {
  var id = 0;
  return function (prefix) {
    var v = ++id;
    if (prefix) {
      v = prefix + v;
    }
    return v;
  };
});

